<!-- prettier-ignore -->
 
@if(!isFullScreen()){
    <ion-header>
        <ion-toolbar class="iframe-toolbar">
            @if(title){
                <ion-title>{{title}}</ion-title>
            }
        <ion-buttons slot="end">
            <ion-icon (click)="goToFullScreen()" name="expand-outline"></ion-icon>
            <ion-icon (click)="dismissModal()" name="close"></ion-icon>
        </ion-buttons>
        </ion-toolbar>
    </ion-header>
}

<ion-content class="iframe-wrapper">
    @if(isFullScreen()){
        <div class="close-button-iframe">
            <ion-icon (click)="dismissModal()" name="close"></ion-icon>
        </div>
    }

    <iframe [src]="iframeSrc" frameborder="0" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-presentation" allowfullscreen></iframe>
</ion-content>
  